export default "__VITE_ASSET__DXmIViU1__"